import { render, staticRenderFns } from "./CASEItemTile.vue?vue&type=template&id=20e61f44"
import script from "./CASEItemTile.vue?vue&type=script&lang=js"
export * from "./CASEItemTile.vue?vue&type=script&lang=js"
import style0 from "./CASEItemTile.vue?vue&type=style&index=0&id=20e61f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
